"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Ganymede = undefined;

var _ice = require("ice");

var _Exceptions = require("../AuthExceptions/Exceptions");

// **********************************************************************
//
// Copyright (c) 2003-2017 ZeroC, Inc. All rights reserved.
//
// This copy of Ice is licensed to you under the terms described in the
// ICE_LICENSE file included in this distribution.
//
// **********************************************************************
//
// Ice version 3.7.0
//
// <auto-generated>
//
// Generated from file `Ganymede/ClientManager.ice'
//
// Warning: do not edit this file.
//
// </auto-generated>
//

const _ModuleRegistry = _ice.Ice._ModuleRegistry;
const Slice = _ice.Ice.Slice;

let Ganymede = _ModuleRegistry.module("Ganymede");

const iceC_Ganymede_Project_ids = ["::Ganymede::Project", "::Ice::Object"];

Ganymede.Project = class extends _ice.Ice.Value {
    constructor(id = "", name = "") {
        super();
        this.id = id;
        this.name = name;
    }

    _iceWriteMemberImpl(ostr) {
        ostr.writeString(this.id);
        ostr.writeString(this.name);
    }

    _iceReadMemberImpl(istr) {
        this.id = istr.readString();
        this.name = istr.readString();
    }
};

Slice.defineValue(Ganymede.Project, iceC_Ganymede_Project_ids[0], false);

Ganymede.ProjectDisp = class extends _ice.Ice.Object {};

Slice.defineOperations(Ganymede.ProjectDisp, undefined, iceC_Ganymede_Project_ids, 0);

Slice.defineSequence(Ganymede, "ProjectSeqHelper", "Ice.ObjectHelper", false, "Ganymede.Project");

const iceC_Ganymede_Client_ids = ["::Ganymede::Client", "::Ice::Object"];

Ganymede.Client = class extends _ice.Ice.Value {
    constructor(identity = "", projectId = "", name = "") {
        super();
        this.identity = identity;
        this.projectId = projectId;
        this.name = name;
    }

    _iceWriteMemberImpl(ostr) {
        ostr.writeString(this.identity);
        ostr.writeString(this.projectId);
        ostr.writeString(this.name);
    }

    _iceReadMemberImpl(istr) {
        this.identity = istr.readString();
        this.projectId = istr.readString();
        this.name = istr.readString();
    }
};

Slice.defineValue(Ganymede.Client, iceC_Ganymede_Client_ids[0], false);

Ganymede.ClientDisp = class extends _ice.Ice.Object {};

Slice.defineOperations(Ganymede.ClientDisp, undefined, iceC_Ganymede_Client_ids, 0);

Slice.defineSequence(Ganymede, "ClientSeqHelper", "Ice.ObjectHelper", false, "Ganymede.Client");

Ganymede.InvalidName = class extends _ice.Ice.UserException {
    constructor(message = "", _cause = "") {
        super(_cause);
        this.message = message;
    }

    static get _parent() {
        return _ice.Ice.UserException;
    }

    static get _id() {
        return "::Ganymede::InvalidName";
    }

    _mostDerivedType() {
        return Ganymede.InvalidName;
    }

    _writeMemberImpl(ostr) {
        ostr.writeString(this.message);
    }

    _readMemberImpl(istr) {
        this.message = istr.readString();
    }
};

Ganymede.ProjectNotExists = class extends _ice.Ice.UserException {
    constructor(_cause = "") {
        super(_cause);
    }

    static get _parent() {
        return _ice.Ice.UserException;
    }

    static get _id() {
        return "::Ganymede::ProjectNotExists";
    }

    _mostDerivedType() {
        return Ganymede.ProjectNotExists;
    }
};

Ganymede.ClientExists = class extends _ice.Ice.UserException {
    constructor(_cause = "") {
        super(_cause);
    }

    static get _parent() {
        return _ice.Ice.UserException;
    }

    static get _id() {
        return "::Ganymede::ClientExists";
    }

    _mostDerivedType() {
        return Ganymede.ClientExists;
    }
};

Ganymede.ClientNotExists = class extends _ice.Ice.UserException {
    constructor(_cause = "") {
        super(_cause);
    }

    static get _parent() {
        return _ice.Ice.UserException;
    }

    static get _id() {
        return "::Ganymede::ClientNotExists";
    }

    _mostDerivedType() {
        return Ganymede.ClientNotExists;
    }
};

const iceC_Ganymede_ClientManager_ids = ["::Ganymede::ClientManager", "::Ice::Object"];

Ganymede.ClientManager = class extends _ice.Ice.Object {};

Ganymede.ClientManagerPrx = class extends _ice.Ice.ObjectPrx {};

Slice.defineOperations(Ganymede.ClientManager, Ganymede.ClientManagerPrx, iceC_Ganymede_ClientManager_ids, 0, {
    "createProject": [,,,, ["Ganymede.Project", true], [[7]],, [_Exceptions.AuthExceptions.AuthException, Ganymede.InvalidName],, true],
    "getProjects": [, 2, 2,, ["Ganymede.ProjectSeqHelper"],,, [_Exceptions.AuthExceptions.AuthException],, true],
    "createClient": [,,,, ["Ganymede.Client", true], [[7], [7]],, [_Exceptions.AuthExceptions.AuthException, Ganymede.ClientExists, Ganymede.InvalidName, Ganymede.ProjectNotExists],, true],
    "deleteClient": [,,,,, [[7], [7]],, [_Exceptions.AuthExceptions.AuthException, Ganymede.ClientNotExists],,],
    "getClients": [, 2, 2,, ["Ganymede.ClientSeqHelper"], [[7]],, [_Exceptions.AuthExceptions.AuthException],, true],
    "createClientToken": [,,,, [7], [[7], [7]],, [_Exceptions.AuthExceptions.AuthException, Ganymede.ClientNotExists],,]
});
exports.Ganymede = Ganymede;


//////////////////
// WEBPACK FOOTER
// ./~/@slices/Ganymede/ClientManager.js
// module id = 464
// module chunks = 0